// @charset "utf-8";
// 混合对象 mixins

import keyList from '../lib/key-list'
export default {
    components: {
        'key-list': keyList
    },
    data () {
        return {
            defaultSentence: '',
            searchVis: false,
            searchList: [],
            filterKey: [ 37, 38, 39, 40, 13 ],
            chunkSeparator: [ ',', '，', ';', '；', '。', ' ' ]
        }
    },
    methods: {
        hideSearchList () {
            this.searchVis = false
        },
        updateInput (value) {
            this.sentence = value
        },
        nochecked () {
            this.sentence = this.defaultSentence
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/backtest/backtest-base.js